// extracted by mini-css-extract-plugin
module.exports = {"SolutionSection":"SolutionSection_SolutionSection__3u_UA"};